// extracted by mini-css-extract-plugin
export default {"canvasProject":"CanvasProject_canvasProject__E5NKv"};